const initOverlayImage = ( yandexMapHelper ) => {
	const overlay = yandexMapHelper.component.querySelector( `div.overlay` );
	
	if ( overlay )
	{
		const {image, coords: coordsObject} = JSON.parse(overlay.dataset.overlay);
		
		if ( !image || !coordsObject )
		{
			return;
		}
		
		if ( !coordsObject[0] || !coordsObject[1] || !coordsObject[2] || !coordsObject[3] )
		{
			return;
		}
		
		const coordinates = [[coordsObject[0],coordsObject[1]],[coordsObject[2],coordsObject[3]]];
		
		const overlayImageManager = yandexMapHelper.createObjectManager(
			`overlay-image-manager`,
			{}
		);
		
		const overlayImageProps = {
			type: `Feature`,
			id: `overlay-image`,
			geometry: {
				type: `Rectangle`,
				coordinates,
			},
			properties: {},
			options: {
				hideIconOnBalloonOpen: true,
				balloonShadow: false,
				balloonPanelMaxMapArea: 0,
				openBalloonOnClick: false,
				
				fillImageHref: image,
				fillMethod: `stretch`,
				stroke: false,
				
				visible: false,
				zIndex: 0,
				cursor: `default`,
			},
		};
		
		overlayImageManager.add( overlayImageProps );
	}
};

export {
	initOverlayImage,
};
